import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AppInitializer } from './AppInitializer';
import { GlobalErrorHandler } from './GlobalErrorHandler';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { LoaderService } from './loader.service';
import { PDFViewerComponent } from './pdfviewer/pdfviewer.component';

@NgModule({
    declarations: [AppComponent, PDFViewerComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
    ],
    providers: [
        LoaderService,
        AppInitializer,
        {
            provide: APP_INITIALIZER,
            useFactory: (app: AppInitializer) => () => app.Init(),
            deps: [AppInitializer],
            multi: true,
        },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
